import React, { Component, Fragment } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../config/images/gambar';
import Stempel from '../../../config/images/stempel';
import Watermark from '../../../config/images/watermark';
import { Link } from 'react-router-dom';
import { getUser } from '../../../services/api-services/krs-api';
import { getSemester } from '../../../services/api-services/filterdropdown';
import { getJadwalDiajukan, validasiButtonCetak, validasiEvaluasi, decisionCetak } from '../../../services/api-services/jadwal-api';
import { sendMessage } from '../../../config/utils/message';
import DateIndo from '../../../config/dateIndo';

var nowDate = new Date();
var tanggal = DateIndo(nowDate);

class JadwalKuliah extends Component {
    state = {
        OptSemester: [],
        listJadwalDiajukan: [],
        user: {
            angkatan: '',
            jurusan: '',
            kdjur: '',
            kurikulum: '',
            nama: '',
            nim: '',
            semester: '',
            smtta: '',
            ta: ''
        },
        isLoad: false
    }

    getAllData = async () => {
        const nim = localStorage.getItem('nim');

        const allPromise = Promise.all([
            getUser(nim),
            getSemester(nim)
        ])

        const promises = await allPromise

        this.setState({
            user: promises[0].data,
            OptSemester: promises[1].data
        })
    }

    getRecentJadwal = async (event, params = this.state.user) => {
        this.setState({ isLoad: true })
        params = {
            ...params,
            semester: event.target.value
        }

        const response = await getJadwalDiajukan(params)
        this.setState({
            listJadwalDiajukan: response.data,
            isLoad: false
        })
    }

    showHideCetak = async () => {
        this.setState({ isLoad: true })
        const response = await validasiButtonCetak()
        this.setState({
            isShowCetak: response.data.button_access,
            isLoad: false
        })
    }

    cekEvaluasi = async () => {
        try {
            const res = await getUser(localStorage.getItem('nim'))
            this.setState({ isLoad: true })
            if (res) {
                this.setState({ dataMhs: res.data }, async () => {
                    const { nim, ta, smtta, kurikulum } = this.state.dataMhs;
                    const response = await validasiEvaluasi(nim, ta, smtta, kurikulum)
                    this.setState({
                        isEval: response.data.access,
                        isLoad: false
                    })
                })
            }
        } catch (error) {
            sendMessage(500);
        }
    };

    cetakDecision = async () => {
        try {
            const res = await getUser(localStorage.getItem('nim'))
            this.setState({ isLoad: true })
            if (res) {
                this.setState({ dataMhs: res.data }, async () => {
                    const { nim } = this.state.dataMhs;
                    const response = await decisionCetak(nim)
                    this.setState({
                        isPrint: response.data.button_access,
                        isKet: response.data.keterangan,
                        isLoad: false
                    })
                })
            }
        } catch (error) {
            sendMessage(500);
        }
    };


    print = (prodi) => {
        const doc = new jsPDF();

        var imageAsia = Image.data;
        var imageWatermark = Watermark.data;

        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();

        // Fungsi untuk watermark di tiap halaman
        const addWatermark = () => {
            doc.addImage(imageWatermark, 'JPEG', 0, 0, width, height);
        };

        // Halaman pertama
        addWatermark();

        doc.addImage(imageAsia, 'JPEG', 95, 6, 19, 19);
        doc.setFont("Times-bold", "bold");
        doc.setFontSize(11.5);
        doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 31, { align: 'center' });

        let fakultas = "";
        if (prodi === "Teknik Informatika" || prodi === "Sistem Komputer" || prodi === "Desain Komunikasi Visual") {
            fakultas = "FAKULTAS TEKNOLOGI DAN DESAIN";
        } else if (prodi === "Akuntansi" || prodi === "Manajemen") {
            fakultas = "FAKULTAS EKONOMI DAN BISNIS";
        }

        doc.setFontSize(11.5);
        doc.text(fakultas, width / 2, 36.5, { align: 'center' });

        doc.setFont("Times-Roman", "normal");
        doc.text('Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225', width / 2, 41.5, { align: 'center' });

        doc.setLineWidth(0.1);
        doc.line(10, 47, 200, 47);

        doc.setFont("Times-bold", "bold");
        doc.text("JADWAL PERKULIAHAN", width / 2, 56, { align: 'center' });

        // Tabel header
        doc.autoTable({
            html: '#headerTabel',
            startY: 63,
            theme: 'plain',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                fontSize: 10.5,
                cellPadding: 1
            },
            margin: { left: 10, right: 10 },
            didDrawPage: (data) => {
                addWatermark(); // tambahkan watermark di tiap halaman headerTabel
            }
        });

        // Tabel isi
        doc.autoTable({
            html: '#printJadwal',
            startY: doc.lastAutoTable.finalY + 10,
            theme: 'grid',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                valign: 'middle'
            },
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 'black',
                valign: 'middle',
                halign: 'center',
                lineWidth: 0.1
            },
            columnStyles: {
                0: { halign: 'center' },
                1: { halign: 'center' },
                3: { halign: 'center' },
                4: { halign: 'center' },
                6: { halign: 'center' },
                7: { halign: 'center' },
                8: { halign: 'center' },
                9: { halign: 'center' },
                10: { halign: 'center' }
            },
            margin: { top: 10, left: 10, right: 10, bottom: 10 },
            didDrawPage: (data) => {
                addWatermark(); // tambahkan watermark di tiap halaman printJadwal
            }
        });

        window.open(doc.output('bloburl'), '_blank');
    }

    printUjian = (prodi, type) => {
        const doc = new jsPDF();

        var imageAsia = Image.data;
        var imageStempel = Stempel.data;
        var imageWatermark = Watermark.data;

        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();

        // Fungsi untuk watermark di tiap halaman
        const addWatermark = () => {
            doc.addImage(imageWatermark, 'JPEG', 0, 0, width, height);
        };

        // Halaman pertama
        addWatermark();

        doc.addImage(imageAsia, 'JPEG', 95, 6, 19, 19);
        doc.addImage(imageStempel, 'JPEG', 130, 125, 30, 30);

        doc.setFont("Times-bold", "bold");
        doc.setFontSize(11.5);
        doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 31, { align: 'center' });

        let fakultas = "";
        if (prodi === "Teknik Informatika" || prodi === "Sistem Komputer" || prodi === "Desain Komunikasi Visual") {
            fakultas = "FAKULTAS TEKNOLOGI DAN DESAIN";
        } else if (prodi === "Akuntansi" || prodi === "Manajemen") {
            fakultas = "FAKULTAS EKONOMI DAN BISNIS";
        }

        doc.setFontSize(11.5);
        doc.text(fakultas, width / 2, 36.5, { align: 'center' });

        doc.setFont("Times-Roman", "normal");
        doc.text('Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225', width / 2, 41.5, { align: 'center' });

        doc.setLineWidth(0.1);
        doc.line(10, 47, 200, 47);

        doc.setFont("Times-bold", "bold");
        doc.text("KARTU " + type, width / 2, 56, { align: 'center' });

        // Header Table
        doc.autoTable({
            html: '#headerTabelUjian',
            startY: 63,
            theme: 'plain',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                fontSize: 10.5,
                cellPadding: 1
            },
            margin: { left: 10, right: 10 },
            didDrawPage: (data) => {
                addWatermark(); // Tambahkan watermark di setiap halaman header
            }
        });

        // Main Table (printUjian)
        doc.autoTable({
            html: '#printUjian',
            startY: doc.lastAutoTable.finalY + 10,
            theme: 'grid',
            styles: {
                font: 'times',
                lineColor: 'black',
                textColor: 'black',
                valign: 'middle'
            },
            headStyles: {
                fillColor: [255, 255, 255],
                lineColor: 'black',
                valign: 'middle',
                halign: 'center',
                lineWidth: 0.1
            },
            columnStyles: {
                0: { halign: 'center' },
                1: { halign: 'center' },
                4: { halign: 'center' },
                5: { cellWidth: 30, minCellHeight: 15 }
            },
            margin: { top: 10, left: 10, right: 10, bottom: 10 },
            didDrawPage: (data) => {
                addWatermark(); // Tambahkan watermark di setiap halaman tabel ujian
            }
        });

        // TTD Table (ttdUjian)
        doc.autoTable({
            html: '#ttdUjian',
            startY: doc.lastAutoTable.finalY + 20,
            theme: 'plain',
            styles: {
                font: 'times',
                fontStyle: 'bold',
                lineColor: 'black',
                textColor: 'black',
                fontSize: 10.5,
                cellPadding: 0.1,
                halign: 'left'
            },
            margin: { left: 137, right: 10, bottom: 10 },
            columnStyles: {
                0: { halign: 'left' },
                1: { halign: 'left' }
            },
            didParseCell: function (data) {
                var rows = data.table.body;
                if (data.row.index === rows.length - 2) {
                    data.cell.styles.cellPadding = -4;
                }
                if (data.row.index === rows.length - 1) {
                    data.cell.styles.cellPadding = 1;
                }
            },
            didDrawPage: (data) => {
                addWatermark(); // Tambahkan watermark di setiap halaman TTD
            }
        });

        window.open(doc.output('bloburl'), '_blank');
    }

    componentDidMount = () => {
        this.getAllData()
        this.showHideCetak()
        this.cekEvaluasi()
        this.cetakDecision()
    }

    render() {
        const { angkatan, jurusan, nama, nim, semester, ta, dosenwali, idjalur } = this.state.user
        const { OptSemester, listJadwalDiajukan, user, isLoad } = this.state

        return (
            <Fragment>
                <div className="smooth mb-2">
                    <div className="col-md-12 mb-3">
                        <div className="row">
                            <div className="col-12 col-xl-8 mb-xl-0">
                                <p className="abu" style={{ fontSize: "15px", fontWeight: "bold", color: "#999999", textTransform: "capitalize" }}>
                                    Akademik&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Jadwal Perkuliahan
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="card card-custom">
                        <div className="card-body">
                            <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                Jadwal Perkuliahan
                            </p>
                            <div className="table-responsive pl-2 pr-2">
                                <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                    <thead></thead>
                                    <tbody>
                                        <tr>
                                            <td>NIM</td>
                                            <td> : </td>
                                            <td>{nim}</td>

                                            <td>Angkatan</td>
                                            <td> : </td>
                                            <td>{angkatan}</td>
                                        </tr>
                                        <tr>
                                            <td>Nama</td>
                                            <td> : </td>
                                            <td>{nama}</td>

                                            <td>Semester</td>
                                            <td> : </td>
                                            <td>
                                                <select className="form-control custom-width" onChange={this.getRecentJadwal}>
                                                    <option value="" hidden>- Pilih Semester -</option>
                                                    {
                                                        OptSemester.map((v, index) => {
                                                            return (
                                                                <option key={index} value={v.semester}>{'Semester ' + v.semester}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Prodi</td>
                                            <td> : </td>
                                            <td colSpan={4}>{jurusan}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br />
                            <br />
                            {/* <Link
                                to={{ pathname: "/jadwal/pilih", state: user }}
                                className="btn btn-add"
                                style={{ marginBottom: '25px' }}>

                                <i className="ti-marker-alt"></i>&nbsp;&nbsp;Pilih Jadwal
                            </Link> */}
                            {
                                isLoad ?
                                    <div id="loaderMhs">
                                        <div className="loader-1 colorful mt-5 mb-2">
                                            <div className="dot" />
                                            <div className="dot" />
                                            <div className="dot" />
                                        </div>
                                        <p align="center" className="mb-5">loading data...</p>
                                    </div>
                                    :
                                    <>
                                        <div className="table-responsive mt-1">
                                            <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Kode MK</th>
                                                        <th>Mata Kuliah</th>
                                                        <th>SKS Teori</th>
                                                        <th>SKS Praktek</th>
                                                        <th>Dosen</th>
                                                        <th>Periode</th>
                                                        <th>Ruang</th>
                                                        <th>Hari</th>
                                                        <th>Jam</th>
                                                        <th>Kelas</th>
                                                        <th>Status Kelas</th>
                                                        <th>B/U</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        listJadwalDiajukan.map((v, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{v.kodemk}</td>
                                                                    <td>{v.namamk}</td>
                                                                    <td>{v.sksteori}</td>
                                                                    <td>{v.skspraktek}</td>
                                                                    <td><a href='#' title={v.namadosen}>{v.kddosen}</a></td>
                                                                    <td>{v.jalur === "Malam" ? v.periode : '-'}</td>
                                                                    <td>{v.ruangan}</td>
                                                                    <td>{v.hari}</td>
                                                                    <td>{v.jam}</td>
                                                                    <td>{v.kelas}</td>
                                                                    <td>{v.statuskelas}</td>
                                                                    <td>{v.bu}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <br />
                                        {
                                            this.state.listJadwalDiajukan.length != 0 ?
                                                <>
                                                    <br />
                                                    <div style={{ float: 'left' }}>
                                                        <button className="btn btn-success" type="button"
                                                            onClick={() => this.print(this.state.user.jurusan)}
                                                        >
                                                            <i className="fa fa-print"></i>&nbsp;&nbsp;Cetak Jadwal .PDF
                                                        </button>
                                                    </div>
                                                    {this.state.isShowCetak && (
                                                        <div className="dropdown mb-1" style={{ float: 'right' }}>
                                                            <button className="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i className="fa fa-print"></i>&nbsp;Cetak Kartu .PDF
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                {this.state.isEval ? (
                                                                    <>
                                                                        {this.state.isPrint && this.state.isKet === "UTS" ? (
                                                                            <a className="dropdown-item" href="#" onClick={() => this.printUjian(this.state.user.jurusan, "UJIAN TENGAH SEMESTER")}><i className="fa fa-print"></i>&nbsp;&nbsp; UTS.</a>
                                                                        ) : this.state.isPrint && this.state.isKet === "UAS" ? (
                                                                            <a className="dropdown-item" href="#" onClick={() => this.printUjian(this.state.user.jurusan, "UJIAN AKHIR SEMESTER")}><i className="fa fa-print"></i>&nbsp;&nbsp; UAS.</a>
                                                                        ) : (
                                                                            <a className="dropdown-item" href="#">Belum bisa cetak Kartu.</a>
                                                                        )}
                                                                    </>
                                                                ) : (
                                                                    <Link className="dropdown-item" to="/evaluasi"><i className="fa fa-pencil"></i>&nbsp;&nbsp;Isi Evaluasi.</Link>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </> : null
                                        }

                                    </>
                            }
                        </div>
                    </div>
                </div>

                {/* print area Jadwal */}
                <div style={{ display: 'none' }}>
                    <table id="headerTabel">
                        <thead></thead>
                        <tbody className='times'>
                            <tr>
                                <td>Nama</td>
                                <td> : </td>
                                <td>{nama}</td>

                                <td>Semester</td>
                                <td> : </td>
                                <td>{semester}</td>
                            </tr>
                            <tr>
                                <td>NIM</td>
                                <td> : </td>
                                <td>{nim}</td>

                                <td>Tahun Akademik</td>
                                <td> : </td>
                                <td>{ta}</td>
                            </tr>
                            <tr>
                                <td>Program Studi</td>
                                <td> : </td>
                                <td>
                                    {jurusan}
                                </td>

                                <td>Wali</td>
                                <td> : </td>
                                <td>{dosenwali}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table id="printJadwal">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Kode MK</th>
                                <th>Mata Kuliah</th>
                                <th>SKS T</th>
                                <th>SKS P</th>
                                <th>Dosen</th>
                                <th>Ruang</th>
                                <th>Hari</th>
                                <th>Jam</th>
                                <th>Kelas</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listJadwalDiajukan.map((v, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{v.kodemk}</td>
                                            <td>{v.namamk}</td>
                                            <td>{v.sksteori}</td>
                                            <td>{v.skspraktek}</td>
                                            <td>{v.namadosen}</td>
                                            <td>{v.ruangan}</td>
                                            <td>{v.hari}</td>
                                            <td>{v.jam}</td>
                                            <td>{v.kelas}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                {/* end of print area Jadwal  */}

                {/* print area Ujian */}
                <div style={{ display: 'none' }}>
                    <table id="headerTabelUjian">
                        <thead></thead>
                        <tbody className='times'>
                            <tr>
                                <td>Nama</td>
                                <td> : </td>
                                <td>{nama}</td>

                                <td>Semester</td>
                                <td> : </td>
                                <td>{semester}</td>
                            </tr>
                            <tr>
                                <td>NIM</td>
                                <td> : </td>
                                <td>{nim}</td>

                                <td>Tahun Akademik</td>
                                <td> : </td>
                                <td>{ta}</td>
                            </tr>
                            <tr>
                                <td>Program Studi</td>
                                <td> : </td>
                                <td>
                                    {jurusan}
                                </td>

                                <td>Wali</td>
                                <td> : </td>
                                <td>{dosenwali}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table id="printUjian">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Kode MK</th>
                                <th>Mata Kuliah</th>
                                <th>SKS T</th>
                                <th>SKS P</th>
                                <th>Dosen</th>
                                <th>Ruang</th>
                                <th>Hari</th>
                                <th>Jam</th>
                                <th>Kelas</th>
                                <th>TTD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listJadwalDiajukan.map((v, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{v.kodemk}</td>
                                            <td>{v.namamk}</td>
                                            <td>{v.sksteori}</td>
                                            <td>{v.skspraktek}</td>
                                            <td>{v.namadosen}</td>
                                            <td>{v.ruangan}</td>
                                            <td>{v.hari}</td>
                                            <td>{v.jam}</td>
                                            <td>{v.kelas}</td>
                                            <td></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>

                    <table id="ttdUjian">
                        <thead></thead>
                        <tbody>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>Malang,  {tanggal}</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>Panitia Ujian,</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>&nbsp;</td>
                                <td>ttd</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                {/* end of print area Ujian  */}
            </Fragment>
        );
    }
}

export default JadwalKuliah;
